import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import { useDispatch } from "react-redux";
import { initDataProveedorUbicacion_Val, initDataProveedorUbicacion_Ex, initDataProveedorDB } from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Checkbox from "../../components/common/Checkbox";
import Validate from "../../utils/Validate";
const ProveedoresDatosUbicacion = ({dataT, keyIndex, handleActualizarFicha, handleChangePaso}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrClasificacion, setArrClasificacion] = useState([]);
  const [arrPais, setArrPais] = useState([]);
  const [arrDepartamento, setArrDepartamento] = useState([]);
  const [arrProvincia, setArrProvincia] = useState([]);
  const [arrDistrito, setArrDistrito] = useState([]);
  const [arrTipoDoc, setArrTipoDoc] = useState([]);
  const [infoModal, setInfoModal] = useState(null);
  const [loadingSelect, setLoadingSelect] = useState(null);
  const [data, setData] = useState(Validate.extraerAtributos(initDataProveedorUbicacion_Ex, dataT));
  const [validacion, setValidacion] = useState({});  
  const [proteccionDisabled, setProteccionDisabled] = useState(false);

  useEffect(() => {    
    setData(Validate.extraerAtributos(initDataProveedorUbicacion_Ex, dataT));
  }, [dataT]);

  useEffect(() => {
    getClasificacion();
    getTipoDocPN();
    getPaises();
    getDepartamentos();
    getProvincias();
    getDistritos();
  }, []);

  const getClasificacion = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','CLASIF_PROV'));
      if (response.ok && response.data && response.data.payload) {
        let clasif = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrClasificacion(clasif);
      }
    } catch (ex) {
      console.log("Error al obtener areas", ex);
    }
  };
  const getCIIU = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.obtenerParametroCodigo.replace('{tipoParametro}','CIIU').replace('{codParametro}',data.idpCiiu));
      if (response.ok && response.data && response.data.payload) {
        handleChange("descCiiu", response.data.payload.descparametro)
      }
    } catch (ex) {
      console.log("Error al obtener areas", ex);
    }
  };
  const getTipoDocPN = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPDOC'));
      if (response.ok && response.data && response.data.payload) {
        let tipdoc = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoDoc(tipdoc);
      }
    } catch (ex) {
      console.log("Error al obtener tipdoc", ex);
    }
  };
  const getPaises = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarPaises);
      if (response.ok && response.data && response.data.payload) {
        let paises = response.data.payload.map((el, index) => {
          return {
            value: el.idpais,
            text: el.descpais
          };
        });
        setArrPais(paises);
      }
    } catch (ex) {
      console.log("Error al obtener getPaises", ex);
    }
  };
  const getDepartamentos = async (ind) => {
    try {
      if((!data.idPais) && !ind){
        return true;
      }else{
        data.idPais = ind || data.idPais;
      }
      setLoadingSelect(true)
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarDepartamentosPais.replace('{idPais}',data.idPais));
      if (response.ok && response.data && response.data.payload) {
        let departamentos = response.data.payload.map((el, index) => {
          return {
            value: el.iddepartamento,
            text: el.descdepartamento
          };
        });
        setArrDepartamento(departamentos);
        setLoadingSelect(false);
      }
    } catch (ex) {
      console.log("Error al obtener getDepartamentos", ex);
    }
  };
  const getProvincias = async (ind) => {
    try {
      if((!data.idDepartamento) && !ind){
        return true;
      }else{
        data.idDepartamento = ind || data.idDepartamento;
      }      
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarProvinciasDep.replace('{idDepartamento}',data.idDepartamento));
      if (response.ok && response.data && response.data.payload) {
        let paises = response.data.payload.map((el, index) => {
          return {
            value: el.idprovincia,
            text: el.descprovincia
          };
        });
        setArrProvincia(paises);
      }
    } catch (ex) {
      console.log("Error al obtener getPaises", ex);
    }
  };
  const getDistritos = async (ind) => {
    try {
      if((!data.idProvincia) && !ind){
        return true;
      }else{
        data.idProvincia = ind || data.idProvincia;
      }
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarDistritosProv.replace('{idProvincia}',data.idProvincia));
      if (response.ok && response.data && response.data.payload) {
        let paises = response.data.payload.map((el, index) => {
          return {
            value: el.iddistrito,
            text: el.descdistrito
          };
        });
        setArrDistrito(paises);
      }
    } catch (ex) {
      console.log("Error al obtener getDistritos", ex);
    }
  };
  const handleChange = (name, value) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    setValidacion({ ...validacion, [name]: false });
  };
  const validarFormulario = () => {
    let resp = true;
    if(data.idpClasificacion=='EEX'){
      delete data.idDepartamento;
      delete data.idProvincia;
      delete data.idDistrito;
    }else{
      data.idDepartamento = !data.idDepartamento?"":data.idDepartamento;
      data.idProvincia = !data.idProvincia?"":data.idProvincia;
      data.idDistrito = !data.idDistrito?"":data.idDistrito;
    }
    for (var name in initDataProveedorUbicacion_Val) {
      if (data.hasOwnProperty(name))
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        /*if(name=='correoNotificacion' && !Validate.validarEmail(data[name])){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        } 
        if(name=='numDocumento' && !Validate.validarDocumento(data.idpTipoDocumento,data[name])){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        }*/      
    }
    return resp;
  }
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };
  
  const handleShowModal = (tag) => {
    setTagBody(tag);
    setInfoModal(true);
  };
  const bodyModal = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">{tag=='PER'?'POLÍTICA DE PRIVACIDAD':'XXXXX'}</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-07 margin-bottom-10 text-justify">
            {tag=='PER'?<><p>Declaro haber sido informado, conforme a Ley N° 29733 - Ley de Protección de Datos Personales (“la Ley”) y al Decreto Supremo 003-2013/JUS - Reglamento de la Ley (“el Reglamento)”, de lo siguiente: </p>

            <p>Los datos personales entregados a RIMAC SEGUROS serán almacenados mientras dure mi relación contractual con RIMAC SEGUROS y hasta por 10 años de culminada la misma en el banco de datos de su titularidad, ubicado en Calle Begonias 540, Distrito de San Isidro, Lima, estando además inscritos en el Registro Nacional de Protección de Datos Personales con la denominación “Proveedores” con código RNPDP-PJP N.° 1634.</p>

            <p>Los datos personales recolectados por RIMAC SEGUROS, serán tratados con la finalidad de realizar la contratación de bienes y servicios, así como, a efectos de supervisar la ejecución de los mismos, para efectuar el pago de los importes pactados, y para realizar un control posterior del servicio prestado o bien adquirido. Estos datos son obligatorios y la negativa a suministrarlos supondrá la imposibilidad de concretar la relación contractual.</p>

            <p>Culminada la relación contractual RIMAC SEGUROS podrá tratar, conservar, organizar, consultar, revisar y evaluar mis datos personales, a efectos de contactarme y solicitarme cotizaciones para cubrir nuevos requerimientos de bienes y/o servicios.</p>            
            <p>Declaro conocer mi derecho a solicitar a acceso a mis datos personales y conocer su tratamiento, así como, solicitar su actualización, inclusión, rectificación, cancelación y supresión, pudiendo oponerme a su uso o divulgación, a través de cualquiera de las Plataformas de Atención de RIMAC SEGUROS o enviando una solicitud al correo electrónico atencionalcliente@rimac.com.pe; teniendo a salvo además el ejercicio de la tutela de mis derechos ante la Autoridad Nacional de Protección de Datos Personales en vía de reclamación o al Poder Judicial para la acción de hábeas data.</p>
            </>:'XXXXXXXXXXXXXXXXXXXXXXXXXX'}
            
          </h4>
        </div>
      </div>
    );
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  
    
  const handleClickRegisterModal = async () => {
      //const { dateTimeCreation, docNumber, clientDoc, id } = selectedRow;
    if(tagBody=="add")
    { 
        const body = {
          payload: {
            
          },
        };
        try {
          dispatch(showLoading());
          const response = await callService(
            "POST",
            CONSTANTES.APIS_PATH.insertArea,
            body
          );
          dispatch(hideLoading());
          // type == 0 => ok , type == 1 => error
          let error = response.data? response.data.type:null;
          if (response.ok && response.data && response.ok == true && error!='1') {
            resetForm();
            setShowAlert({
              show: true,
              title: "Correcto",
              message: response.data.data || "Se guardó el registró",
              type: "success",
            });
            resetMessage(5);
            handleCloseModal(false);            
            setCurrentPage(new Number(1));            
          } else {
            const mesaje = response.message || "Error al registrar";
            setShowAlert({
              show: true,
              title: "Error",
              message: mesaje,
              type: "error",
            });
            resetMessage(5);
          }
          // handleSearchEndpoint();
        } catch (ex) {
          console.log(ex)
          dispatch(hideLoading());
        }
      
    }
    
  };



  return (
    <div className="step__content is-active" data-key={keyIndex}>
        <div className="proveedores_content">
          <h4 className="title-05 margin-bottom-16 margin-top-16">
          <b>Completa la <span class="title-red">dirección de la empresa:</span></b>
          </h4>                  
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="documents_criteria_typeTicket">
              <Select
                label="Clasificación Empresa"
                selected={data && arrClasificacion.find(obj=>obj.value==data.idpClasificacion)}
                onChange={(newValue) => {
                                        data.idpClasificacion = newValue.value;
                                        validacion.idpClasificacion = false;
                                        handleChange("idpClasificacion", newValue.value); 
                                        if(newValue.value == 'EEX'){
                                          data.indDomiciliado = 'N';
                                          data.idPais = '';
                                          validacion.indDomiciliado = false;
                                          handleChange("indDomiciliado", 'N');                                      
                                          handleChange("idPais", '');
                                        }else{
                                          data.indDomiciliado = 'S';
                                          data.idPais = 'PE';
                                          validacion.indDomiciliado = false;
                                          handleChange("indDomiciliado", 'S');                                      
                                          handleChange("idPais", 'PE');
                                        }                                   
                }
                }
                hasError= {validacion.idpClasificacion && '*'} 
                items={arrClasificacion}
              />
            </div>
          </div>      
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="documents_criteria_ciiu">
                <Input
                  label="CIIU"
                  name="idpCiiu"
                  maxLength="10"
                  value={data?.idpCiiu}
                  onChange={(newValue) => handleChange("idpCiiu", String(newValue))}
                  onBlur={() => getCIIU()}
                  onkeydown={(e)=>{
                    if (e.key === "Enter") {
                      getCIIU();
                    }
                  }}
                  customRegex={/^[0-9]*$/}
                  hasError= {validacion.idpCiiu && '*'}                    
                />
            </div>
            <div className="documents_criteria_descciiu">
                <Input
                  label="Descripcion CIIU"
                  name="descCiiu"
                  maxLength="500"
                  value={data?.descCiiu}                    
                />
            </div>
          </div>
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="documents_criteria_typeTicket">
              <Input
                label="Años Experiencia"
                name="aniosExperiencia"
                maxLength="4"
                value={data?.aniosExperiencia}
                onChange={(newValue) => handleChange("aniosExperiencia",  Number(newValue))}
                hasError= {validacion.aniosExperiencia && '*'}
                customRegex={/^[0-9]*$/}                                       
              />
            </div>
          </div>
          <div className="d-justify-space-between d-flex-column-m w100 margin-bottom-16">
            <div className="documents_criteria_datos2">¿Está domiciliado?</div>                 
            <div className="documents_criteria_datos2">
                  <Radio
                      id="indDomiciliadoS"
                      name="indDomiciliado"
                      value="S"
                      onChange={(newValue) => {data.indDomiciliado = newValue;
                                              validacion.indDomiciliado = false;
                                              handleChange("indDomiciliado", newValue);
                                              data.idPais = 'PE';
                                              handleChange("idPais", 'PE');

                      }
                      }
                      isChecked={data?.indDomiciliado}
                      hasError= {validacion.indDomiciliado && '*'} 
                  >
                      Si
                  </Radio>
                  <Radio
                      id="indDomiciliadoN"
                      name="indDomiciliado"
                      value="N"
                      onChange={(newValue) => {data.indDomiciliado = newValue;
                                            validacion.indDomiciliado = false;
                                            handleChange("indDomiciliado", newValue);
                                            data.idPais = '';
                                            handleChange("idPais", '');

                      }
                      } 
                      isChecked={data?.indDomiciliado}
                      hasError= {validacion.indDomiciliado && '*'}               
                  >
                      No
                  </Radio>
            </div>        
          </div> 
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="documents_criteria_datos2">
                <Select
                  label="PAIS"
                  selected={data && arrPais.find(obj=>obj.value==data.idPais)}
                  onChange={(newValue) => {handleChange("idPais", newValue.value);
                                          getDepartamentos(newValue.value)}}
                  items={arrPais}
                  filterable = {true}
                  hasError= {validacion.idPais && '*'}
                />
            </div>
            {data.idpClasificacion && data.idpClasificacion != CONSTANTES.CLASIF_EMP_EXTRANJERA &&
            <div className="documents_criteria_datos2">
                <Select
                  label="DEPARTAMENTO"
                  selected={data && arrDepartamento.find(obj=>obj.value==data.idDepartamento)}
                  onChange={(newValue) => {handleChange("idDepartamento", newValue.value)
                                          getProvincias(newValue.value)}}
                  items={arrDepartamento}
                  filterable = {true}
                  hasError= {validacion.idDepartamento && '*'}
                  //loading={loadingSelect}
                />
            </div>
            }      
          </div>
          {data.idpClasificacion && data.idpClasificacion != CONSTANTES.CLASIF_EMP_EXTRANJERA &&
          <>
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="documents_criteria_datos2">
                <Select
                  label="PROVINCIA"
                  selected={data && arrProvincia.find(obj=>obj.value==data.idProvincia)}
                  onChange={(newValue) => {handleChange("idProvincia", newValue.value)
                                          getDistritos(newValue.value)}}
                  items={arrProvincia}
                  filterable = {true}
                  hasError= {validacion.idProvincia && '*'}
                />
            </div>
            <div className="documents_criteria_datos2">
                <Select
                  label="DISTRITO"
                  selected={data && arrDistrito.find(obj=>obj.value==data.idDistrito)}
                  onChange={(newValue) => handleChange("idDistrito", newValue.value)}
                  items={arrDistrito}
                  filterable = {true}
                  hasError= {validacion.idDistrito && '*'}
                />
            </div>
          </div>
          </>
          }
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="documents_criteria_datos">
              <Input
                label="DIRECCION"
                name="direccion"
                maxLength="1000"
                value={data?.direccion}
                onChange={(newValue) => handleChange("direccion", newValue)}
                hasError= {validacion.direccion && '*'}
                customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}                        
              />
            </div>
          </div>
          <div className="d-justify-space-between d-flex-column-m w100">            
            <div className="documents_criteria_datos">
              <Input
                label="REFERENCIA DE DIRECCION"
                name="refDireccion"
                maxLength="1000"
                value={data?.refDireccion}
                onChange={(newValue) => handleChange("refDireccion", newValue)}
                hasError= {validacion.refDireccion && '*'}
                customRegex={/^[a-zA-Z0-9\.\s\u00f1\u00d1\&]*$/}
              />
            </div>
          </div>
          <div className="d-justify-space-between d-flex-column-m w100 margin-bottom-16">
            <div className="documents_criteria_datos2"> ¿Es local principal?</div>                       
            <div className="documents_criteria_datos2">                 
                  <Radio
                      id="indLocalPrincipalS"
                      name="indLocalPrincipal"
                      value="S"
                      onChange={(newValue) => handleChange("indLocalPrincipal", newValue)}
                      isChecked={data?.indLocalPrincipal}
                      hasError= {validacion.indLocalPrincipal && '*'}
                  >
                      Si
                  </Radio>
                  <Radio
                      id="indLocalPrincipalN"
                      name="indLocalPrincipal"
                      value="N"
                      onChange={(newValue) => handleChange("indLocalPrincipal", newValue)} 
                      isChecked={data?.indLocalPrincipal}
                      hasError= {validacion.indLocalPrincipal && '*'}                           
                  >
                      No
                  </Radio>
            </div>         
          </div>
          <div className="d-justify-space-between d-flex-column-m w100 margin-bottom-16">            
            <div className="documents_criteria_datos">
                <Checkbox 
                  id="indProteccionDatos" 
                  label={<>Acepto la <a className="link-legal">Política de Privacidad</a></>} 
                  checked={data?.indProteccionDatos=='S'}
                  onClick={(newValue) => handleChange("indProteccionDatos", (newValue?'S':'N'))}
                  clickedLabel={true}
                  onClickLabel= {() => handleShowModal("PER")}
                  hasError= {validacion.indProteccionDatos && '*'}
                  disabled = {proteccionDisabled}
                  />
            </div>
          </div>
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_btns d-flex-end margin-bottom-16">
              <div className="documents_btnSearch">
                <Button
                  // type="submit"
                  disabled = {data.indProteccionDatos!="S"}
                  primary
                  size="large"
                  onClick={()=>{
                    if(validarFormulario())
                    { handleActualizarFicha(data);
                      handleChangePaso(keyIndex);
                      setProteccionDisabled(true);
                    }
                  }}
                >
                  Continuar
                </Button>
              </div>                  
            </div>
          </div>
        </div>
        <div className="proveedores_margen">
            <DatosProveedor data={dataT}/>       
        </div>
      <Modal
        className="rd--modal-info-files"
        onToggle={(value) => setInfoModal(false)}
        visible={infoModal}
        width={800}
        fullScreenMobile
        redHoverClosed
        onLabelClosed
        max12Padding
        footer={
          <Button primary onClick={() => setInfoModal(false)}>
            Cerrar
          </Button>
        }
      >
        {bodyModal(tagBody)}
      </Modal>
    </div>
  );
};


export default ProveedoresDatosUbicacion;
